import { Close, Reply as ReplyIcon } from '@mui/icons-material'
import { Avatar, Box, Button, CircularProgress, IconButton, Stack, Typography } from '@mui/material'
import { FC, useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { Comment } from '~/__generated__/graphql'
import { SvgAsset } from '~/components/SvgAsset'
import { useCommentLike } from '~/features/video_detail/hooks/comments/useCommentLike'
import { useCommentsMutation } from '~/features/video_detail/hooks/comments/useCommentsMutation'
import { useRepliesMutation } from '~/features/video_detail/hooks/replies/useCommentReplies'
import { formatPostedDate } from '~/libs/format'
import { Colors } from '~/libs/mui/theme'
import { CommentInputForm } from './CommentInputForm'
import RepliesList from './RepliesList'

const CommentRow: FC<{
  comment: Comment
}> = ({ comment }) => {
  const [showsInput, setShowsInput] = useState(false)
  const { t } = useTranslation()
  const { data: likeQuery, onClickLike } = useCommentLike(comment.videoId.toString(), comment.id)
  const { deleteComment } = useCommentsMutation(comment.videoId.toString())
  const { createReply } = useRepliesMutation(comment.videoId.toString(), comment.id)
  const [showReplies, setShowReplies] = useState(false)

  return (
    <Stack>
      <Stack spacing={1}>
        <Box display='flex' alignItems='center' gap={1}>
          <Avatar src={comment.user?.avatar ?? ''} />
          <Typography flexGrow={1} color={Colors.yellow}>
            {comment.user?.name}
          </Typography>
          <Typography color={Colors.color5A5957}>
            {formatPostedDate(comment.createdAt ?? undefined)}
          </Typography>
        </Box>
        <Typography
          component='pre'
          color={Colors.color91908F}
          sx={{ whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}
        >
          {comment.contents}
        </Typography>

        <Box display='flex'>
          <Button
            sx={{
              color: likeQuery?.currentUserHasLike == true ? Colors.yellow : Colors.color5A5957,
            }}
            startIcon={<SvgAsset asset='like' />}
            onClick={onClickLike}
          >
            {likeQuery?.likeNum ?? 0}
          </Button>
          <Button
            sx={{ color: Colors.color5A5957 }}
            onClick={() => {
              setShowsInput(!showsInput)
            }}
          >
            <ReplyIcon />
          </Button>
          <Box flexGrow={1} />
          {/* TODO: delete or violation report button */}
          {comment?.isMine == true && (
            <IconButton
              sx={{ color: Colors.color5A5957 }}
              onClick={() => {
                if (confirm(t('delete_review'))) {
                  deleteComment(comment.id)
                }
              }}
            >
              <Close />
            </IconButton>
          )}
        </Box>

        {showsInput && (
          <CommentInputForm
            placeholder='reply'
            onSubmitComment={async (contents) => {
              await createReply(contents)
              setShowsInput(false)
            }}
          />
        )}
      </Stack>

      {(comment.replies?.totalCount ?? 0) > 0 ? (
        showReplies ? (
          <RepliesList videoId={comment.videoId.toString()} commentId={comment.id} />
        ) : false ? (
          <CircularProgress />
        ) : !!false ? (
          <></>
        ) : (
          <Button
            onClick={() => setShowReplies(true)}
            sx={{
              marginBottom: 1,
            }}
          >
            <Trans i18nKey='reply_num' values={{ num: comment.replies?.totalCount }} />
          </Button>
        )
      ) : (
        <></>
      )}
    </Stack>
  )
}

export default CommentRow
